export const WEB_APP_URL = process.env.REACT_APP_WEB_APP_URL;
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const FOOTWEAR_WEB_APP_URL = process.env.REACT_APP_FOOTWEAR_WEB_APP_URL;

export const SUCCESS_OR_ERROR_RESULT = true;

export const MODAL_STEPS = {
  CONSENT: { number: 0 },
  GENDER: { number: 1 },
  INTRO_MOBILE: { number: 2 },
  INTRO: { number: 3 },
  DEVICE_SELECT: { number: 4 },
  SHOE_GENDER: { number: 5 },
  SHOE_SIZES: { number: 6 },
  SHOE_QUESTIONS: { number: 7 },
  QR_CODE: { number: 8 },
  BELLY: { number: 9 },
  TORSO: { number: 10 },
  CUISSES: { number: 11 },
  BREASTS: { number: 12 },
  SLEEVES: { number: 13 },
  LINGERIE_QUESTION_1: { number: 14 },
  LINGERIE_QUESTION_2: { number: 15 },
  LINGERIE_QUESTION_3: { number: 16 },
  LINGERIE_QUESTION_4: { number: 17 },
  ERROR: { number: 18 },
  RESULT: { number: 19 },
  UNAVAILABLE_RESULT: { number: 20 },
  ANTI_BRACKETING: { number: 21 },
};

export const GENDERS = {
  F: "female",
  M: "male",
};

export const BASE_SIZES = [
  {
    name: "UK",
    image: "UK",
    label: "UK",
    band_sizes: [
      {
        size: 28,
        fr: 75,
      },
      {
        size: 30,
        fr: 80,
      },
      {
        size: 32,
        fr: 85,
      },
      {
        size: 34,
        fr: 90,
      },
      {
        size: 36,
        fr: 95,
      },
      {
        size: 38,
        fr: 100,
      },
      {
        size: 40,
        fr: 105,
      },
      {
        size: 42,
        fr: 110,
      },
      {
        size: 44,
        fr: 115,
      },
      {
        size: 46,
        fr: 120,
      },
      {
        size: 48,
        fr: 125,
      },
    ],
    cup_sizes: [
      {
        size: "AA",
        fr: "AA",
      },
      {
        size: "A",
        fr: "A",
      },
      {
        size: "B",
        fr: "B",
      },
      {
        size: "C",
        fr: "C",
      },
      {
        size: "D",
        fr: "D",
      },
      {
        size: "DD",
        fr: "E",
      },
      {
        size: "E",
        fr: "F",
      },
      {
        size: "F",
        fr: "G",
      },
      {
        size: "FF",
        fr: "H",
      },
      {
        size: "G",
        fr: "I",
      },
      {
        size: "GG",
        fr: "J",
      },
      {
        size: "H",
        fr: "K",
      },
    ],
  },
  {
    name: "EU",
    image: "EU",
    label: "Europe",
    band_sizes: [
      {
        size: 60,
        fr: 75,
      },
      {
        size: 65,
        fr: 80,
      },
      {
        size: 70,
        fr: 85,
      },
      {
        size: 75,
        fr: 90,
      },
      {
        size: 80,
        fr: 95,
      },
      {
        size: 85,
        fr: 100,
      },
      {
        size: 90,
        fr: 105,
      },
      {
        size: 95,
        fr: 110,
      },
      {
        size: 100,
        fr: 115,
      },
      {
        size: 105,
        fr: 120,
      },
      {
        size: 110,
        fr: 125,
      },
    ],
    cup_sizes: [
      {
        size: "AA",
        fr: "AA",
      },
      {
        size: "A",
        fr: "A",
      },
      {
        size: "B",
        fr: "B",
      },
      {
        size: "C",
        fr: "C",
      },
      {
        size: "D",
        fr: "D",
      },
      {
        size: "E",
        fr: "E",
      },
      {
        size: "F",
        fr: "F",
      },
      {
        size: "G",
        fr: "G",
      },
      {
        size: "H",
        fr: "H",
      },
      {
        size: "I",
        fr: "I",
      },
      {
        size: "J",
        fr: "J",
      },
      {
        size: "K",
        fr: "K",
      },
    ],
  },
  {
    name: "US",
    image: "US",
    label: "USA",
    band_sizes: [
      {
        size: 28,
        fr: 75,
      },
      {
        size: 30,
        fr: 80,
      },
      {
        size: 32,
        fr: 85,
      },
      {
        size: 34,
        fr: 90,
      },
      {
        size: 36,
        fr: 95,
      },
      {
        size: 38,
        fr: 100,
      },
      {
        size: 40,
        fr: 105,
      },
      {
        size: 42,
        fr: 110,
      },
      {
        size: 44,
        fr: 115,
      },
      {
        size: 46,
        fr: 120,
      },
      {
        size: 48,
        fr: 125,
      },
    ],
    cup_sizes: [
      {
        size: "AA",
        fr: "AA",
      },
      {
        size: "A",
        fr: "A",
      },
      {
        size: "B",
        fr: "B",
      },
      {
        size: "C",
        fr: "C",
      },
      {
        size: "D",
        fr: "D",
      },
      {
        size: "DD/E",
        fr: "E",
      },
      {
        size: "DDD/F",
        fr: "F",
      },
      {
        size: "DDDD/G",
        fr: "G",
      },
      {
        size: "H",
        fr: "H",
      },
      {
        size: "I",
        fr: "I",
      },
      {
        size: "J",
        fr: "J",
      },
      {
        size: "K",
        fr: "K",
      },
    ],
  },
  {
    name: "AUS",
    image: "AUS",
    label: "Australia",
    band_sizes: [
      {
        size: 6,
        fr: 75,
      },
      {
        size: 8,
        fr: 80,
      },
      {
        size: 10,
        fr: 85,
      },
      {
        size: 12,
        fr: 90,
      },
      {
        size: 14,
        fr: 95,
      },
      {
        size: 16,
        fr: 100,
      },
      {
        size: 18,
        fr: 105,
      },
      {
        size: 20,
        fr: 110,
      },
      {
        size: 22,
        fr: 115,
      },
      {
        size: 24,
        fr: 120,
      },
      {
        size: 26,
        fr: 125,
      },
    ],
    cup_sizes: [
      {
        size: "AA",
        fr: "AA",
      },
      {
        size: "A",
        fr: "A",
      },
      {
        size: "B",
        fr: "B",
      },
      {
        size: "C",
        fr: "C",
      },
      {
        size: "D",
        fr: "D",
      },
      {
        size: "DD/E",
        fr: "E",
      },
      {
        size: "DDD/F",
        fr: "F",
      },
      {
        size: "DDDD/G",
        fr: "G",
      },
      {
        size: "H",
        fr: "H",
      },
      {
        size: "I",
        fr: "I",
      },
      {
        size: "J",
        fr: "J",
      },
      {
        size: "K",
        fr: "K",
      },
    ],
  },
  {
    name: "IT",
    image: "IT",
    label: "Italy",
    band_sizes: [
      {
        size: 0,
        fr: 75,
      },
      {
        size: 1,
        fr: 80,
      },
      {
        size: 2,
        fr: 85,
      },
      {
        size: 3,
        fr: 90,
      },
      {
        size: 4,
        fr: 95,
      },
      {
        size: 5,
        fr: 100,
      },
      {
        size: 6,
        fr: 105,
      },
      {
        size: 7,
        fr: 110,
      },
      {
        size: 8,
        fr: 115,
      },
      {
        size: 9,
        fr: 120,
      },
      {
        size: 10,
        fr: 125,
      },
    ],
    cup_sizes: [
      {
        size: "AA",
        fr: "AA",
      },
      {
        size: "A",
        fr: "A",
      },
      {
        size: "B",
        fr: "B",
      },
      {
        size: "C",
        fr: "C",
      },
      {
        size: "D",
        fr: "D",
      },
      {
        size: "E",
        fr: "E",
      },
      {
        size: "F",
        fr: "F",
      },
      {
        size: "G",
        fr: "G",
      },
      {
        size: "H",
        fr: "H",
      },
      {
        size: "I",
        fr: "I",
      },
      {
        size: "J",
        fr: "J",
      },
      {
        size: "K",
        fr: "K",
      },
    ],
  },
  {
    name: "JP",
    image: "JP",
    label: "Japan",
    band_sizes: [
      {
        size: 60,
        fr: 75,
      },
      {
        size: 65,
        fr: 80,
      },
      {
        size: 70,
        fr: 85,
      },
      {
        size: 75,
        fr: 90,
      },
      {
        size: 80,
        fr: 95,
      },
      {
        size: 85,
        fr: 100,
      },
      {
        size: 90,
        fr: 105,
      },
      {
        size: 95,
        fr: 110,
      },
      {
        size: 100,
        fr: 115,
      },
      {
        size: 105,
        fr: 120,
      },
      {
        size: 110,
        fr: 125,
      },
    ],
    cup_sizes: [
      {
        size: "A",
        fr: "AA",
      },
      {
        size: "B",
        fr: "A",
      },
      {
        size: "C",
        fr: "B",
      },
      {
        size: "D",
        fr: "C",
      },
      {
        size: "E",
        fr: "D",
      },
      {
        size: "F",
        fr: "E",
      },
      {
        size: "G",
        fr: "F",
      },
      {
        size: "H",
        fr: "G",
      },
      {
        size: "I",
        fr: "H",
      },
      {
        size: "J",
        fr: "I",
      },
      {
        size: "K",
        fr: "J",
      },
      {
        size: "L",
        fr: "K",
      },
    ],
  },
  {
    name: "KO",
    image: "KO",
    label: "Korea",
    band_sizes: [
      {
        size: 60,
        fr: 75,
      },
      {
        size: 65,
        fr: 80,
      },
      {
        size: 70,
        fr: 85,
      },
      {
        size: 75,
        fr: 90,
      },
      {
        size: 80,
        fr: 95,
      },
      {
        size: 85,
        fr: 100,
      },
      {
        size: 90,
        fr: 105,
      },
      {
        size: 95,
        fr: 110,
      },
      {
        size: 100,
        fr: 115,
      },
      {
        size: 105,
        fr: 120,
      },
      {
        size: 110,
        fr: 125,
      },
    ],
    cup_sizes: [
      {
        size: "B",
        fr: "AA",
      },
      {
        size: "C",
        fr: "A",
      },
      {
        size: "D",
        fr: "B",
      },
      {
        size: "E",
        fr: "C",
      },
      {
        size: "F",
        fr: "D",
      },
      {
        size: "G",
        fr: "E",
      },
      {
        size: "H",
        fr: "F",
      },
      {
        size: "I",
        fr: "G",
      },
      {
        size: "J",
        fr: "H",
      },
      {
        size: "K",
        fr: "I",
      },
      {
        size: "L",
        fr: "J",
      },
      {
        size: "M",
        fr: "K",
      },
    ],
  },
  {
    name: "FR",
    image: "FR",
    label: "France",
    band_sizes: [
      {
        size: 75,
      },
      {
        size: 80,
      },
      {
        size: 85,
      },
      {
        size: 90,
      },
      {
        size: 95,
      },
      {
        size: 100,
      },
      {
        size: 105,
      },
      {
        size: 110,
      },
      {
        size: 115,
      },
      {
        size: 120,
      },
      {
        size: 125,
      },
    ],
    cup_sizes: [
      {
        size: "AA",
        fr: "AA",
      },
      {
        size: "A",
        fr: "A",
      },
      {
        size: "B",
        fr: "B",
      },
      {
        size: "C",
        fr: "C",
      },
      {
        size: "D",
        fr: "D",
      },
      {
        size: "E",
        fr: "E",
      },
      {
        size: "F",
        fr: "F",
      },
      {
        size: "G",
        fr: "G",
      },
      {
        size: "H",
        fr: "H",
      },
      {
        size: "I",
        fr: "I",
      },
      {
        size: "J",
        fr: "J",
      },
      {
        size: "K",
        fr: "K",
      },
    ],
  },
];

export const ERROR_EMPTY = {
  height: {
    error: false,
    message: "",
  },
  weight: {
    error: false,
    message: "",
  },
  age: {
    error: false,
    message: "",
  },
  ageChildren: {
    error: false,
    message: "",
  },
  company: {
    error: false,
    message: "",
  },
};

export const VALIDATION_RULES = {
  height: {
    min: 120,
    max: 230,
    feet: {
      min: 3,
      max: 11,
    },
    inches: {
      min: 7,
      max: 6,
    },
  },
  weight: {
    kg: {
      min: 20,
      max: 200,
    },
    lbs: {
      min: 44,
      max: 439,
    },
  },
  age: {
    min: 1,
    max: 100,
  },
};

export const SHOES_BASE_SIZES = [
  {
    name: "EU",
    image: "EU",
    label: "Europe",
    sizes: [
      {
        male: 34.0,
        female: 34.0,
      },
      {
        male: 34.5,
        female: 34.5,
      },
      {
        male: 35.0,
        female: 35.0,
      },
      {
        male: 35.5,
        female: 35.5,
      },
      {
        male: 36.0,
        female: 36.0,
      },
      {
        male: 36.5,
        female: 36.5,
      },
      {
        male: 37.0,
        female: 37.0,
      },
      {
        male: 37.5,
        female: 37.5,
      },
      {
        male: 38.0,
        female: 38.0,
      },
      {
        male: 38.5,
        female: 38.5,
      },
      {
        male: 39.0,
        female: 39.0,
      },
      {
        male: 39.5,
        female: 39.5,
      },
      {
        male: 40.0,
        female: 40.0,
      },
      {
        male: 40.5,
        female: 40.5,
      },
      {
        male: 41.0,
        female: 41.0,
      },
      {
        male: 41.5,
        female: 41.5,
      },
      {
        male: 42.0,
        female: 42.0,
      },
      {
        male: 42.5,
        female: 42.5,
      },
      {
        male: 43.0,
        female: 43.0,
      },
      {
        male: 43.5,
        female: 43.5,
      },
      {
        male: 44.0,
        female: 44.0,
      },
      {
        male: 44.5,
        female: 44.5,
      },
      {
        male: 45.0,
        female: 45.0,
      },
      {
        male: 45.5,
        female: 45.5,
      },
      {
        male: 46.0,
        female: 46.0,
      },
      {
        male: 46.5,
        female: 46.5,
      },
      {
        male: 47.0,
        female: 47.0,
      },
      {
        male: 47.5,
        female: 47.5,
      },
      {
        male: 48.0,
        female: 48.0,
      },
      {
        male: 48.5,
        female: 48.5,
      },
      {
        male: 49.0,
        female: 49.0,
      },
      {
        male: 49.5,
        female: 49.5,
      },
      {
        male: 50.0,
        female: 50.0,
      },
      {
        male: 50.5,
        female: 50.5,
      },
    ],
  },
  {
    name: "US",
    image: "US",
    label: "USA",
    sizes: [
      {
        male: 2.0,
        female: 3.5,
      },
      {
        male: 2.5,
        female: 4.0,
      },
      {
        male: 3.0,
        female: 4.5,
      },
      {
        male: 3.5,
        female: 5.0,
      },
      {
        male: 4.0,
        female: 5.5,
      },
      {
        male: 4.5,
        female: 6.0,
      },
      {
        male: 5.0,
        female: 6.5,
      },
      {
        male: 5.5,
        female: 7.0,
      },
      {
        male: 6.0,
        female: 7.5,
      },
      {
        male: 6.5,
        female: 8.0,
      },
      {
        male: 7.0,
        female: 8.5,
      },
      {
        male: 8.0,
        female: 9.0,
      },
      {
        male: 8.5,
        female: 9.5,
      },
      {
        male: 9.0,
        female: 10.0,
      },
      {
        male: 9.5,
        female: 10.5,
      },
      {
        male: 10.0,
        female: 11.0,
      },
      {
        male: 10.5,
        female: 11.5,
      },
      {
        male: 11.0,
        female: 12.0,
      },
      {
        male: 11.5,
        female: 12.5,
      },
      {
        male: 12.0,
        female: 13.0,
      },
      {
        male: 12.5,
        female: 13.5,
      },
      {
        male: 13.0,
        female: 14.0,
      },
      {
        male: 13.5,
        female: 14.5,
      },
      {
        male: 14.0,
        female: 15.0,
      },
      {
        male: 14.5,
        female: 15.5,
      },
      {
        male: 15.0,
        female: 16.0,
      },
      {
        male: 15.5,
        female: 16.5,
      },
      {
        male: 16.0,
        female: 17.0,
      },
      {
        male: 16.5,
        female: 17.5,
      },
      {
        male: 17.0,
        female: 18.0,
      },
      {
        male: 17.5,
        female: 18.5,
      },
      {
        male: 18.0,
        female: 19.0,
      },
    ],
  },
  {
    name: "UK",
    image: "UK",
    label: "UK",
    sizes: [
      {
        male: 1.5,
        female: 1.0,
      },
      {
        male: 2.0,
        female: 1.5,
      },
      {
        male: 2.5,
        female: 2.0,
      },
      {
        male: 3.0,
        female: 2.5,
      },
      {
        male: 3.5,
        female: 3.0,
      },
      {
        male: 4.0,
        female: 3.5,
      },
      {
        male: 4.5,
        female: 4.0,
      },
      {
        male: 5.0,
        female: 4.5,
      },
      {
        male: 5.5,
        female: 5.0,
      },
      {
        male: 6.0,
        female: 5.5,
      },
      {
        male: 6.5,
        female: 6.0,
      },
      {
        male: 7.0,
        female: 6.5,
      },
      {
        male: 7.5,
        female: 7.0,
      },
      {
        male: 8.0,
        female: 7.5,
      },
      {
        male: 8.5,
        female: 8.0,
      },
      {
        male: 9.0,
        female: 8.5,
      },
      {
        male: 9.5,
        female: 9.0,
      },
      {
        male: 10.0,
        female: 9.5,
      },
      {
        male: 10.5,
        female: 10.0,
      },
      {
        male: 11.0,
        female: 10.5,
      },
      {
        male: 11.5,
        female: 11.0,
      },
      {
        male: 12.0,
        female: 11.5,
      },
      {
        male: 12.5,
        female: 12.0,
      },
      {
        male: 13.0,
        female: 12.5,
      },
      {
        male: 13.5,
        female: 13.0,
      },
      {
        male: 14.0,
        female: 13.5,
      },
      {
        male: 14.5,
        female: 14.0,
      },
      {
        male: 15.0,
        female: 14.5,
      },
      {
        male: 15.5,
        female: 15.0,
      },
      {
        male: 16.0,
        female: 15.5,
      },
      {
        male: 16.5,
        female: 16.0,
      },
      {
        male: 17.0,
        female: 16.5,
      },
    ],
  },
];

export const VANESSA_LIMITS = {
  EU: { min: 35, max: 43 },
  US: { min: 3, max: 11.5 },
  UK: { min: 2.5, max: 10.5 },
};

// Secondary language-based rules
export const LANGUAGE_RULES: Record<
  string,
  { unit: "metric" | "imperial"; bra: string }
> = {
  fr: { unit: "metric", bra: "FR" },
  it: { unit: "metric", bra: "IT" },
  es: { unit: "metric", bra: "FR" },
  en: { unit: "imperial", bra: "US" },
  ja: { unit: "metric", bra: "JP" },
  ko: { unit: "metric", bra: "KO" },
  us: { unit: "imperial", bra: "US" },
  default: { unit: "metric", bra: "EU" },
};
